<template>
    <section>
    <div class="guest-checkout-container shipping-information" v-if="isOpen && (!isLoggedIn || !props.addresses.length)">
        <p class="title-l text-rothcoBlack">Shipping Information</p>
        <div class="form-field-container">
            <div class="grid-2">
                <div class="authorization-input_label">
                    <InputText 
                        :aria-required="true"
                        @focus="togglePlaceholder('first_name')"
                        @blur="togglePlaceholder('first_name')"
                        id="first_name" v-model="firstName"
                        :class="{
                            'authorization-first_name_input': true,
                            'invalid-state-input': errors.shipping_first_name != null,
                        }"
                        :placeholder="!placeholdersHidden.get('first_name') ? 'First Name / Company *' : ''" 
                        fluid
                    />
                    <label
                        :class="{'invalid-state': errors.shipping_first_name}"
                        for="first_name">
                        <p>First Name / Company *</p>
                    </label>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_first_name">{{ errors.shipping_first_name }}</p></div>
                </div>
                <div class="authorization-input_label">
                    <InputText
                        @focus="togglePlaceholder('last_name')"
                        @blur="togglePlaceholder('last_name')"
                        id="last_name" v-model="lastName"
                        :class="{
                            'authorization-last_name_input': true,
                            'invalid-state-input': errors.shipping_last_name != null,
                        }"
                        :placeholder="!placeholdersHidden.get('last_name') ? 'Last Name' : ''" 
                        fluid
                    />
                    <label
                        for="last_name">
                        <p>Last Name</p>
                    </label>
                </div>
            </div>
            <div class="authorization-input_label">
                <InputText
                    :aria-required="true"
                    @focus="togglePlaceholder('address')"
                    @blur="togglePlaceholder('address')"
                    id="address" v-model="address"
                    :class="{
                        'authorization-address_input': true,
                        'invalid-state-input': errors.shipping_address != null,
                    }"
                    :placeholder="!placeholdersHidden.get('address') ? 'Address *' : ''" 
                    fluid
                />
                <label
                    :class="{'invalid-state': errors.shipping_address}"
                    for="address">
                    <p>Address *</p>
                </label>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_address">{{ errors.shipping_address }}</p></div>
            </div>
            <div class="authorization-input_label">
                <InputText
                    @focus="togglePlaceholder('address_2')"
                    @blur="togglePlaceholder('address_2')"
                    id="address_2" v-model="address2"
                    :class="{
                        'authorization-address_2_input': true,
                    }"
                    :placeholder="!placeholdersHidden.get('address_2') ? 'Address Line 2 (Optional)' : ''" 
                    fluid
                />
                <label
                    for="address_2">
                    <p>Address Line 2 (Optional)</p>
                </label>
            </div>
            <div class="grid-3">
                <div class="authorization-input_label">
                    <InputText
                        :aria-required="true"
                        @focus="togglePlaceholder('city')"
                        @blur="togglePlaceholder('city')"
                        id="city" v-model="city"
                        :class="{
                            'authorization-city_input': true,
                            'invalid-state-input': errors.shipping_city != null,
                        }"
                        :placeholder="!placeholdersHidden.get('city') ? 'City *' : ''" 
                        fluid
                    />
                    <label
                        :class="{'invalid-state': errors.shipping_city}"
                        for="city">
                        <p>City *</p>
                    </label>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_city">{{ errors.shipping_city }}</p></div>
                </div>
                <div class="selectore-state select-wrapper">
                    <CustomSelect
                        name="state" id="state" label="State" v-model="state" :options="props.regions"
                        :class="{'invalid-state-input': errors.shipping_state != null}"
                    />
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_state">{{ errors.shipping_state }}</p></div>
                </div>
                <div class="authorization-input_label">
                    <InputText
                        :aria-required="true"
                        @focus="togglePlaceholder('zipcode')"
                        @blur="togglePlaceholder('zipcode')"
                        id="zipcode" v-model="zip"
                        :class="{
                            'authorization-zipcode_input': true,
                            'invalid-state-input': errors.shipping_zip != null,
                        }"
                        :placeholder="!placeholdersHidden.get('zipcode') ? 'Zip Code *' : ''" 
                        fluid
                    />
                    <label
                        :class="{'invalid-state': errors.shipping_zip}"
                        for="zipcode">
                        <p>Zip Code *</p>
                    </label>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_zip">{{ errors.shipping_zip }}</p></div>
                </div>
            </div>
            <div class="container flex-row" v-if="showPoBoxCheckbox">
                <input type="checkbox" id="po_box_checkbox" v-model="shippingPOBoxValue" aria-label="Is this a PO Box?"/>
                <p class="paragraph-details">Is this a PO Box?</p>
            </div>
            <p v-show="taxErrorMessage" class="invalid-state">
                {{ taxErrorMessage }}
            </p>
            <p v-show="!isValid && validAddress && !taxErrorMessage">
                The address you entered is invalid. Please enter a valid
                address.
            </p>
            <p v-show="isDifferent && validAddress">
                The address you entered is different from the suggested address.
                <span style="text-decoration: underline; cursor: pointer;" @click="openSuggestedAddressModal()"
                    >Would you like to use the suggested address?</span
                >
            </p>
            <p v-if="!isLoggedIn" class="paragraph-details shipping-us-message">Rothco currently only ships within the United States. If you live outside of the US please search for a dealer in your country <a target="_blank" :href="route('retail.locator.show')" class="paragraph-details">here.</a></p>
        </div>
    </div>
    <div v-else-if="isOpen" class="guest-checkout-container shipping-method">
        <div class="flex flex-row" style="justify-content: space-between;">
            <p class="title-l text-rothcoBlack">Shipping Information</p>
            <div class="bg-rothcoCream accordion-button" @click="isOpen = false">
                <AccordionArrow class="icon-open"/>
            </div>
        </div>
        <div class="radio-group" role="radiogroup">
            <label class="option" v-for="(addr, index) of props.addresses" :key="index" @click="setSelectedShippingInfo(addr)">
                <input v-model="selectedShippingInfo" :value="addr.customer_address_id" type="radio" name="shipping_info" :id="`shipping_info_${index}`">
                <div class="label-container">
                    <p class="paragraph-details">
                    {{ getAddressFullName(addr) }}, {{ addr.shipping_street1 }},
                    <span
                        v-if="
                            addr.shipping_street2 != '' &&
                            addr.shipping_street2 != null
                        "
                        >{{ addr.shipping_street2 }},</span
                    >
                    </p>
                    <p class="paragraph-details">
                        {{ addr.shipping_city }}, {{ addr.shipping_state }} {{ addr.shipping_postal_code }}
                    </p>
                </div>
            </label>
            <div class="option bg-rothcoCream" style="padding-top: 1rem;" v-if="selectedShippingInfo == 'new' && isLoggedIn && props.addresses.length">
                <div class="form-field-container">
                    <div class="grid-2">
                        <div class="authorization-input_label">
                            <InputText 
                                :aria-required="selectedShippingInfo == 'new'"
                                @focus="togglePlaceholder('first_name')"
                                @blur="togglePlaceholder('first_name')"
                                id="first_name" v-model="firstName"
                                :class="{
                                    'authorization-first_name_input': true,
                                    'invalid-state-input': errors.shipping_first_name != null,
                                }"
                                :placeholder="!placeholdersHidden.get('first_name') ? 'First Name / Company *' : ''" 
                                fluid
                            />
                            <label
                                :class="{'invalid-state': errors.shipping_first_name}"
                                for="first_name">
                                <p>First Name / Company *</p>
                            </label>
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_first_name">{{ errors.shipping_first_name }}</p></div>
                        </div>
                        <div class="authorization-input_label">
                            <InputText
                                @focus="togglePlaceholder('last_name')"
                                @blur="togglePlaceholder('last_name')"
                                id="last_name" v-model="lastName"
                                :class="{
                                    'authorization-last_name_input': true,
                                    'invalid-state-input': errors.shipping_last_name != null,
                                }"
                                :placeholder="!placeholdersHidden.get('last_name') ? 'Last Name' : ''" 
                                fluid
                            />
                            <label
                                for="last_name">
                                <p>Last Name</p>
                            </label>
                        </div>
                    </div>
                    <div class="authorization-input_label">
                        <InputText
                            :aria-required="selectedShippingInfo == 'new'"
                            @focus="togglePlaceholder('address')"
                            @blur="togglePlaceholder('address')"
                            id="address" v-model="address"
                            :class="{
                                'authorization-address_input': true,
                                'invalid-state-input': errors.shipping_address != null,
                            }"
                            :placeholder="!placeholdersHidden.get('address') ? 'Address *' : ''" 
                            fluid
                        />
                        <label
                            :class="{'invalid-state': errors.shipping_address}"
                            for="address">
                            <p>Address *</p>
                        </label>
                        <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_address">{{ errors.shipping_address }}</p></div>
                    </div>
                    <div class="authorization-input_label">
                        <InputText
                            @focus="togglePlaceholder('address_2')"
                            @blur="togglePlaceholder('address_2')"
                            id="address_2" v-model="address2"
                            :class="{
                                'authorization-address_2_input': true,
                            }"
                            :placeholder="!placeholdersHidden.get('address_2') ? 'Address Line 2 (Optional)' : ''" 
                            fluid
                        />
                        <label
                            for="address_2">
                            <p>Address Line 2 (Optional)</p>
                        </label>
                    </div>
                    <div class="grid-3">
                        <div class="authorization-input_label">
                            <InputText
                                :aria-required="selectedShippingInfo == 'new'"
                                @focus="togglePlaceholder('city')"
                                @blur="togglePlaceholder('city')"
                                id="city" v-model="city"
                                :class="{
                                    'authorization-city_input': true,
                                    'invalid-state-input': errors.shipping_city != null,
                                }"
                                :placeholder="!placeholdersHidden.get('city') ? 'City *' : ''" 
                                fluid
                            />
                            <label
                                :class="{'invalid-state': errors.shipping_city}"
                                for="city">
                                <p>City *</p>
                            </label>
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_city">{{ errors.shipping_city }}</p></div>
                        </div>
                        <div class="selectore-state select-wrapper">
                            <CustomSelect
                                :aria-required="selectedShippingInfo == 'new'"
                                name="state" id="state" label="State" v-model="state" :options="props.regions"
                                :class="{'invalid-state-input': errors.shipping_state != null}"
                            />
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_state">{{ errors.shipping_state }}</p></div>
                        </div>
                        <div class="authorization-input_label">
                            <InputText
                                :aria-required="selectedShippingInfo == 'new'"
                                @focus="togglePlaceholder('zipcode')"
                                @blur="togglePlaceholder('zipcode')"
                                id="zipcode" v-model="zip"
                                :class="{
                                    'authorization-zipcode_input': true,
                                    'invalid-state-input': errors.shipping_zip != null,
                                }"
                                :placeholder="!placeholdersHidden.get('zipcode') ? 'Zip Code *' : ''" 
                                fluid
                            />
                            <label
                                :class="{'invalid-state': errors.shipping_zip}"
                                for="zipcode">
                                <p>Zip Code *</p>
                            </label>
                            <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.shipping_zip">{{ errors.shipping_zip }}</p></div>
                        </div>
                    </div>
                    <div class="container flex-row" v-if="showPoBoxCheckbox">
                        <input type="checkbox" id="po_box_checkbox" v-model="shippingPOBoxValue" aria-label="Is this a PO Box?"/>
                        <p class="paragraph-details">Is this a PO Box?</p>
                    </div>
                    <p v-show="!isValid && validAddress">
                        The address you entered is invalid. Please enter a valid
                        address.
                    </p>
                    <p v-show="isDifferent && validAddress">
                        The address you entered is different from the suggested address.
                        <span id="use_suggested" style="text-decoration: underline; cursor: pointer;" @click="openSuggestedAddressModal()"
                            >Would you like to use the suggested address?</span
                        >
                    </p>
                </div>
            </div>
        </div>
        <p v-if="selectedShippingInfo != 'new'" 
            class="add-apartment paragraph-details text-rothcoRed hide-billing" 
            style="cursor: pointer;"
            @click="selectedShippingInfo = 'new'">
            + Use a different shipping address.
        </p>
    </div>
    <div v-else class="guest-checkout-container shipping-information" id="shipping_info_collapsed">
        <div class="flex flex-row" style="justify-content: space-between;">
            <p class="title-l text-rothcoBlack">Shipping Information</p>
            <div class="bg-rothcoCream accordion-button" @click="isOpen = true">
                <AccordionArrow />
            </div>
        </div>
        <p v-if="validAddress" class="paragraph-details">
        {{ getAddressFullName({shipping_first_name: firstName, shipping_last_name: lastName}) }}, {{ address }},
        <span class="paragraph-details" v-if="address2 != '' && address2 != null">{{ address2 }},</span>
        </p>
        <p v-if="validAddress" class="paragraph-details">
            {{ city }}, {{ state?.value }} {{ zip }}
        </p>
    </div>
    </section>
</template>
<script lang="ts" setup>
    import InputText from 'primevue/inputtext';
    import { computed, watch, ref, onMounted, toRefs } from "vue";
    import { route } from "ziggy-js";
    import { useDialog } from "primevue/usedialog";
    import AccordionArrow from "@icons/accordion-arrow.svg";
    import SuggestedAddressModal from "@/components/SuggestedAddressModal.vue";

    let firstName = defineModel("firstName", {
        type: String,
        default: ""
    });
    let lastName = defineModel("lastName", {
        type: String,
        default: ""
    });
    let phoneNumber = defineModel("phoneNumber", {
        type: String,
        default: ""
    });
    let address = defineModel("address", {
        type: String,
        default: ""
    });
    let address2 = defineModel("address2", {
        type: String,
        default: ""
    });
    let city = defineModel("city", {
        type: String,
        default: ""
    });
    let state = defineModel("state", {
        type: String,
        default: ""
    });
    let zip = defineModel("zip", {
        type: String,
        default: ""
    });
    let shippingPOBoxValue = ref(false);
    let shipping_is_po_box = defineModel("shipping_is_po_box", {
        type: String,
        default: "0"
    })

    watch(shippingPOBoxValue, (newVal)=>{
        if(newVal){
            shipping_is_po_box.value = '1';
        }else{
            shipping_is_po_box.value = '0';
        }
    });

    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {}
        }
    })

    let showPoBoxCheckbox = ref(false);

    let props = defineProps({
        user: {
            type: Object,
            default() {
                return {};
            }
        },
        addresses: {
            type: Object,
            default() {
                return {};
            }
        },
        useSuggestedAddress: {
            type: Function,
            default() {
                return () => {};
            }
        },
        isValid: {
            type: Boolean,
            default: false
        },
        isDifferent: {
            type: Boolean,
            default: false
        },
        regions: {
            type: Array<Object>,
            default: [] 
        },
        open: {
            type: Boolean,
            default: false
        },
        taxErrorMessage: {
            type: Boolean,
            default: false
        },
    });

    let selectedShippingInfo = ref("new");

    let isNewAddress = defineModel("isNewAddress", {
        type: Boolean,
        default: false
    })

    const defaultAddress = computed(()=>{
        return props.addresses?.find(addr=>addr.is_default == 1) ?? props.addresses?.[0] ?? null;
    })

    const setSelectedShippingInfo = (addr: any) => {
        if(addr && addr.shipping_street1){
            selectedShippingInfo.value = addr.customer_address_id
        }else{
            selectedShippingInfo.value = `new`;
        }
    };

    let isLoggedIn = computed(() => {
        return !!(props.user && props.user.email);
    });

    let isOpen = ref(props.open);

    let validAddress = computed(() => {
        return (
            firstName.value != "" &&
            firstName.value != null &&
            address.value != "" &&
            address.value != null &&
            city.value != "" &&
            city.value != null &&
            state.value != "" &&
            state.value != null &&
            zip.value != "" &&
            zip.value != null
        );
    });

    const newShippingAddress = computed(()=>{
        return {
            address: address.value,
            address2: address2.value,
            city: city.value,
            state: state.value?.code,
            zip: zip.value,
            country: "USA"
        }
    })

    let dialog = useDialog();
    let openSuggestedAddressModal = () => {
        dialog.open(SuggestedAddressModal, {
            props: {
                showHeader: false,
            },
            data: {
                oldAddress: newShippingAddress.value,
                newAddress: props.useSuggestedAddress(),
            },
            onClose: (props) => {
                if(props?.data?.useSuggestedAddress){
                    changeAddress();
                }
            }
        })
    };
    
    function changeAddress() {
        let addy = props.useSuggestedAddress();

        address.value = addy.street1;
        address2.value = addy.street2;

        city.value = addy.city;
        state.value = props.regions.find((s) => s.key == addy.state);
        zip.value = addy.postal_code;
    }

    const placeholdersHidden = ref(new Map());
    function togglePlaceholder(id) {
        if(!placeholdersHidden.value.has(id)) {
            placeholdersHidden.value.set(id, true);
        }else{
            placeholdersHidden.value.set(id, !placeholdersHidden.value.get(id));
        }
    }

    function getAddressFullName({ shipping_first_name, shipping_last_name }) {
        //if there is no last name, return the first name
        if (!shipping_last_name) {
            return shipping_first_name;
        }
        return `${shipping_first_name} ${shipping_last_name}`;
    }

    let emits = defineEmits(['shippingAddressUpdated']);

    watch(()=>props.user?.user_id, (newVal, oldVal)=>{
        if(newVal != oldVal){
            setSelectedShippingInfo(defaultAddress.value);
        }
    }, {immediate: true})

    watch(selectedShippingInfo, (newVal) => {
        if (newVal != "new") {
            const selectedShippingInfoObj = props.addresses.find(
                (a) => a?.customer_address_id == newVal
            );
            firstName.value = selectedShippingInfoObj.shipping_first_name;
            lastName.value = selectedShippingInfoObj.shipping_last_name;
            if(selectedShippingInfoObj.shipping_phone) phoneNumber.value = selectedShippingInfoObj.shipping_phone;
            address.value = selectedShippingInfoObj.shipping_street1;
            address2.value = selectedShippingInfoObj.shipping_street2;
            city.value = selectedShippingInfoObj.shipping_city;
            state.value = {
                'value': selectedShippingInfoObj.shipping_state,
                'key': selectedShippingInfoObj.shipping_state
            }
            zip.value = selectedShippingInfoObj.shipping_postal_code;
            isNewAddress.value = false;
        } else {
            firstName.value = "";
            lastName.value = "";
            address.value = "";
            address2.value = "";
            city.value = "";
            state.value = "";
            zip.value = "";
            isNewAddress.value = true;
        }
    }, {immediate: true});
    watch(address, (newVal)=>{
        if(newVal?.toLowerCase().startsWith('po')){
            showPoBoxCheckbox.value = true;
        }else{
            showPoBoxCheckbox.value = false;   
        }
    });


    watch([firstName, lastName, address, address2, city, state, zip], (newVal)=>{
        emits('shippingAddressUpdated');
    });
</script>
<style lang="scss" scoped>
.icon-open {
    transform: scaleY(-1);
    -moz-transform: scaleY(-1);
    -webkit-transform: scaleY(-1);
    -ms-transform: scaleY(-1);
}
.accordion-button {
    padding: 0.375rem 0.8rem; 
    height: 50%; 
    cursor: pointer; 
    border-radius: 0.25rem;
}
</style>
